import React, { useMemo, useState } from 'react';
import useWatchError from '../../../../shared/hooks/useWatchError';
import useMyWorkspacesChildren from '../../../../redux/workspace/hooks/useMyWorkspacesChildren';
import { Stack } from '@mui/material';
import WorkspaceItem, { WorkspaceItemSkeleton } from './WorkspaceItem';
import WorkspaceListLayout from './WorkspaceListLayout';
import WorkspaceDashboard from './WorkspaceDashboard';
import WorkspaceAdminActions from './WrokspaceAdminActions';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function WorkspaceSkeletons() {
  return (
    <Stack spacing={1}>
      {[...Array(3)].map((_, index) => (
        <WorkspaceItemSkeleton key={index} />
      ))}
    </Stack>
  );
}

function WorkspaceAdminList() {
  const {
    data: workspacesChildren,
    error: workspacesChildrenError,
    isLoading: workspacesChildrenLoading,
  } = useMyWorkspacesChildren();

  const error = workspacesChildrenError;
  useWatchError(error);
  const navigate = useNavigate();
  const listWorkspace = useMemo(
    () => Object.values(workspacesChildren || {}),
    [workspacesChildren]
  );
  const [workspaceIdSelected, setWorkspaceIdSelected] = useState<string | null>(
    null
  );

  const onSearch = (item: any) => {
    setWorkspaceIdSelected(item.id);
  };
  const { t } = useTranslation();
  const showRightPanel = Boolean(workspaceIdSelected);
  const addNewWorkspace = [
    {
      label: t('workspaces.add_new'),
      onClick: () => navigate('/markets/create'),
    },
  ];
  const content = workspacesChildrenLoading ? (
    <WorkspaceSkeletons />
  ) : (
    <Stack spacing={1}>
      <WorkspaceAdminActions options={addNewWorkspace} />
      {listWorkspace?.map((workspace) => (
        <WorkspaceItem
          workspaceId={workspace.childId}
          workspaceIdSelected={workspaceIdSelected}
          key={workspace.childId}
        />
      ))}
    </Stack>
  );

  return (
    <WorkspaceListLayout
      innerContainerMaxWidth={'lg'}
      role="markets"
      onSearch={onSearch}
      showRightPanel={showRightPanel}
      rightPanel={<WorkspaceDashboard workspaceId={workspaceIdSelected} />}
    >
      {content}
    </WorkspaceListLayout>
  );
}

export default WorkspaceAdminList;
